import { createSelector } from '@reduxjs/toolkit';
import { AppState } from 'store';
import { IJobsState } from './jobs.interface';

export const jobsStateSelector = ({ jobs }: AppState): IJobsState => jobs;

export const getSimilarIdsSelector = createSelector(jobsStateSelector, ({ similarIds }: IJobsState) => similarIds);
